export const NETBOX_DOMAIN = 'https://box.cutwise.com';
export const NEXTBOX_DOMAIN = 'box.cutwise.link';

export const NETBOX_STATUS_DISABLED = 0;
export const NETBOX_STATUS_IDLE = 1;
export const NETBOX_STATUS_ACTIVE = 2;
